import React from 'react';
import { cn } from '../../lib/utils';
import { useData } from '../../hooks/useData';
import { dataManager } from '../../utils/dataManager';

export const AppLogo: React.FC<{ className?: string }> = ({ className }) => {
  const customLogo = useData(() => dataManager.getAppLogo());

  // Use custom logo if set, otherwise fallback to permanent default UK Wildcats logo
  const logoSrc = customLogo || '/logo/AppLogo.jpeg';

  return (
    <div className={cn("relative flex items-center justify-center rounded-xl shadow-lg overflow-hidden", className)}>
      <img
        src={logoSrc}
        alt="App Logo"
        className="w-full h-full object-cover"
      />
    </div>
  );
};